import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
/*
  Generated class for the HttpProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HttpProvider {

  constructor(public http: Http) {
    console.log('Hello HttpProvider Provider');
  }
  public getJsonData(type : string){
    console.log('attempting httpget')
    return this.http.get('http://hotelsalden.azurewebsites.net/api/' + type).map(res => res.json());
  }
}


// WEBPACK FOOTER //
// ./src/providers/http/HttpProvider.ts